import api from '../../services/api'
import errorHandlerShow from '../errorHandlerShow/index.js'


const buildRequestQuery = (values, setAlert) => {
    var request = {
        type_query: values.type_query,
        last_evaluated_key: ""
    }

    if (values.type_query === 'query') {
        var filters;
        if (values.system_name) {
            filters = [{'attribute': 'entity_name', 'value': values.entity_name, 'condition': 'Equal to'},
            {'attribute': 'system_name', 'value': values.system_name, 'condition': values.condition}]
        } else {
            filters = [{'attribute': 'entity_name', 'value': values.entity_name, 'condition': 'Equal to'}]
        }
        request = {...request, filters: filters}
    } else if (values.type_query === 'scan') {
        request = {...request, filters: values.filters}
    } else {
        setAlert({
            header: '',
            message: "necessário selecionar pelo menos uma opção scan|query",
            type: '',
            options_btn: []}
        )
    }

    return request
}


const onSubmitSearch = (
    values,
    setLoading,
    setLoadingData,
    setEntities,
    setQuery,
    pk_user,
    token,
    setToken,
    setAlert,
    setShowAlert
) => {
    setLoading(true)
    setLoadingData(true)
    setEntities([])
    setQuery(values)

    const data = buildRequestQuery(values, setAlert)

    api.get('integration-layer/entities', {
        params: {"data": data, 'pk_user': pk_user},
        headers: {'Authorization': token}
    }).then(response => {
        setEntities(response.data.data.entities)
        setLoading(false)
        setLoadingData(false)
    })
    .catch(error => {
        errorHandlerShow(error, setToken, setAlert, setShowAlert)
        setLoading(false)
        setLoadingData(false)
    })
}

export default onSubmitSearch;